import { render, staticRenderFns } from "./SuppliesInfocardCreateForm.vue?vue&type=template&id=849b7c08&"
import script from "./SuppliesInfocardCreateForm.vue?vue&type=script&lang=js&"
export * from "./SuppliesInfocardCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports